import { CodeListItem } from './types-store';
import { CodeFieldIncludeInactiveKey } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { CodeItemCodesAccess } from 'app/area/codetable/item/types';
import { FilterSearchModel } from 'app/area/search-filters/types-store';

export const ACTION = {
  REQUEST_CODE_ITEMS: 'CODETABLE_ADMINISTRATION_LIST:REQUEST_CODE_ITEMS',
  RECEIVE_CODE_ITEMS: 'CODETABLE_ADMINISTRATION_LIST:RECEIVE_CODE_ITEMS',
  FAIL_CODE_ITEMS: 'CODETABLE_ADMINISTRATION_LIST:FAIL_CODE_ITEMS',

  REQUEST_CODETABLE_ADMINISTRATION_LIST: 'CODETABLE_ADMINISTRATION_LIST:REQUEST_CODETABLE_ADMINISTRATION_LIST',
  RECEIVE_CODETABLE_ADMINISTRATION_LIST: 'CODETABLE_ADMINISTRATION_LIST:RECEIVE_CODETABLE_ADMINISTRATION_LIST',
  FAIL_CODETABLE_ADMINISTRATION_LIST: 'CODETABLE_ADMINISTRATION_LIST:FAIL_CODETABLE_ADMINISTRATION_LIST',

  REQUEST_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_LIST:REQUEST_CODE_ITEM_DELETE',
  RECEIVE_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_LIST:RECEIVE_CODE_ITEM_DELETE',
  FAIL_CODE_ITEM_DELETE: 'CODETABLE_ADMINISTRATION_LIST:FAIL_CODE_ITEM_DELETE',

  EXPAND_CODE_ITEM: 'CODETABLE_ADMINISTRATION_LIST:EXPAND_CODE_ITEM',

  INVALIDATE_CODE_ITEMS: 'CODETABLE_ADMINISTRATION_LIST:INVALIDATE_CODE_ITEMS',

  UPDATE_CATEGORY: 'CODETABLE_ADMINISTRATION_LIST:UPDATE_CATEGORY',
  UPDATE_QUERY: 'CODETABLE_ADMINISTRATION_LIST:UPDATE_QUERY',
  UPDATE_INCLUDE_INACTIVE: 'CODETABLE_ADMINISTRATION_LIST:UPDATE_INCLUDE_INACTIVE',

  REQUEST_CODES_ACCESS: 'CODETABLE_ADMINISTRATION_LIST:REQUEST_CODES_ACCESS',
  RECEIVE_CODES_ACCESS: 'CODETABLE_ADMINISTRATION_LIST:RECEIVE_CODES_ACCESS',
  FAIL_CODES_ACCESS: 'CODETABLE_ADMINISTRATION_LIST:FAIL_CODES_ACCESS',
  CLEAR_CODES_ACCESS: 'CODETABLE_ADMINISTRATION_LIST:CLEAR_CODES_ACCESS',

  UPDATE_SEARCH_MODEL: 'CODETABLE_ADMINISTRATION_LIST:UPDATE_SEARCH_MODEL',
  RESET_LIST_STATE: 'CODETABLE_ADMINISTRATION_LIST:RESET_LIST_STATE'
};

export class RequestCodeItems {
  public type: string = ACTION.REQUEST_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel) {
  }
}

export class ReceiveCodeItems {
  public type: string = ACTION.RECEIVE_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel,
    public codeItems: CodeListItem[], public numberOfResults: number, public clearList: boolean) {
  }
}

export class FailCodeItems {
  public type: string = ACTION.FAIL_CODE_ITEMS;
  constructor(public codetableId: number, public parentId: number, public categoryId: number, public searchModel: FilterSearchModel) {
  }
}

export class RequestCodetableAdministrationList {
  public type: string = ACTION.REQUEST_CODETABLE_ADMINISTRATION_LIST;
}

export class ReceiveCodetableAdministrationList {
  public type: string = ACTION.RECEIVE_CODETABLE_ADMINISTRATION_LIST;
  constructor(public options: CodeComplexValue<number>[]) {
  }
}

export class FailCodetableAdministrationList {
  public type: string = ACTION.FAIL_CODETABLE_ADMINISTRATION_LIST;
}

export class RequestCodeItemDelete {
  public type: string = ACTION.REQUEST_CODE_ITEM_DELETE;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItemDelete {
  public type: string = ACTION.RECEIVE_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class FailCodeItemDelete {
  public type: string = ACTION.FAIL_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class ExpandCodeItem {
  public type: string = ACTION.EXPAND_CODE_ITEM;
  constructor(public parentId: number) {
  }
}

export class InvalidateCodeItems {
  public type: string = ACTION.INVALIDATE_CODE_ITEMS;
}

export class UpdateCategory {
  public type: string = ACTION.UPDATE_CATEGORY;
  constructor(public value: CodeComplexValue<number>) {
  }
}

export class UpdateQuery {
  public type: string = ACTION.UPDATE_QUERY;
  constructor(public value: string) {
  }
}

export class UpdateIncludeInactive {
  public type: string = ACTION.UPDATE_INCLUDE_INACTIVE;
  constructor(public value: CodeFieldIncludeInactiveKey) {
  }
}

export class RequestCodesAccess {
  public type: string = ACTION.REQUEST_CODES_ACCESS;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodesAccess {
  public type: string = ACTION.RECEIVE_CODES_ACCESS;
  constructor(public accessCodes: CodeItemCodesAccess) {
  }
}

export class FailCodesAccess {
  public type: string = ACTION.FAIL_CODES_ACCESS;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ClearCodesAccess {
  public type: string = ACTION.CLEAR_CODES_ACCESS;
}

export class UpdateSearchModel {
  public type: string = ACTION.UPDATE_SEARCH_MODEL;
  constructor(public model: FilterSearchModel) {
  }
}

export class ResetListState {
  public type: string = ACTION.RESET_LIST_STATE;
}
